/* Glide slider */
import Glide from '@glidejs/glide';

class ProfetSlider {
	constructor() {}
	init() {
		this.setupDefaultSlider();
	}
	setupDefaultSlider() {
		const config = {
			type: 'carousel',
			//autoplay: 4000,
			//peek: 0,
			//perView: 1,
			animationDuration: 500,
			//gap: 15,
		};

		let sliders = document.querySelectorAll('.default-slider');
		if (!sliders) {
			return;
		}
		sliders.forEach((slider) => {
			//let glide = new Glide('.default-slider', config).mount();
			let glide = new Glide(slider, config).mount();
		});
	}
}
window.addEventListener('load', () => {
	window.ProfetSlider = new ProfetSlider();
	window.ProfetSlider.init();
});
